import React from 'react';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';

export default function SortDropdown({
	list,
	value,
	setValue,
	width = '100%',
}) {
	return (
		<Dropdown bsPrefix='sort-dropDown'>
			<Dropdown.Toggle variant='secondary'>{value}</Dropdown.Toggle>

			<Dropdown.Menu variant='dark'>
				{list.map((item, index) => {
					return (
						<Dropdown.Item
							key={index}
							active={item === value}
							onClick={() => setValue(item)}
						>
							{item}
						</Dropdown.Item>
					);
				})}
			</Dropdown.Menu>
		</Dropdown>
	);
}
